export const environment = {
  production: true,
  isTest: false,
  pendoApiKey: '655595c7-e6ff-4285-7a23-31928f997024'
};
